import { render, staticRenderFns } from "./turnup.vue?vue&type=template&id=1d9b1bf8&scoped=true&"
import script from "./turnup.vue?vue&type=script&lang=js&"
export * from "./turnup.vue?vue&type=script&lang=js&"
import style0 from "./turnup.vue?vue&type=style&index=0&id=1d9b1bf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9b1bf8",
  null
  
)

export default component.exports